import { createContext, ReactNode, RefObject, useContext } from "react";

interface RightSidebarContextType {
  portalRef: RefObject<HTMLDivElement>;
}

const RightSidebarContext = createContext<RightSidebarContextType | null>(null);

export const useRightSidebarContext = () => {
  const context = useContext(RightSidebarContext);
  if (!context) {
    throw new Error(
      "useRightSidebarContext must be used within RightSidebarProvider"
    );
  }
  return context;
};

interface RightSidebarProviderProps {
  children: ReactNode;
  portalRef: RefObject<HTMLDivElement>;
}

export const RightSidebarProvider = ({
  children,
  portalRef,
}: RightSidebarProviderProps) => {
  return (
    <RightSidebarContext.Provider value={{ portalRef }}>
      {children}
    </RightSidebarContext.Provider>
  );
};

export default RightSidebarProvider;
